// @flow
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './sample.module.scss'

interface Props {
  className?: string
}

const UISample = ({ className = '' }: Props) => (
  <span className={`${styles.sample} ${className} tx-10`}>
    <FormattedMessage id="ui.sample" defaultMessage="Sample" />
  </span>
)

export default UISample
